import { gql } from "@apollo/client";

export const GET_PRIVACY_POLICY = gql`
  query ($type: PrivacyPolicyEnumType!) {
    getPrivacyPolicy(type: $type) {
      errors {
        message
      }
      data {
        title
        body
        footer
        type
      }
    }
  }
`;
